import React from "react";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import { setStepTradeTableFetchDataFlag } from "../../../Features/Step/stepSlice";
import { CommonTableUI } from "../../TableTemplate/common";
import { StepTradeTableAdditional } from "./StepTradeTableAdditional";
import { IStepTradeTableReport } from "../../../Interfaces/stepInterfaces";

const StepTradeTableUI: React.FC<ITableUI<IStepTradeTableReport>> = ({
  reports,
  onAction,
  onTableHeaderClick,
  onTableRowClick,
  sortingType,
  setSortingType,
}: ITableUI<IStepTradeTableReport>) => {
  const dispatch = useAppDispatch();
  const stopFetchTradeTableHandler = () => {
    dispatch(setStepTradeTableFetchDataFlag(false));
  };

  const tradeTableFetchDataFlag = useAppSelector(
    (store) => store.step.tradeTableFetchDataFlag
  );

  React.useEffect(() => {
    if (!!tradeTableFetchDataFlag && onAction) {
      onAction();
      stopFetchTradeTableHandler();
    }
  }, [tradeTableFetchDataFlag]);

  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={StepTradeTableAdditional}
      onTableHeaderClick={onTableHeaderClick}
      onTableRowClick={onTableRowClick}
      sortingType={sortingType}
      setSortingType={setSortingType}
      tableBoxClassName="max-h-[500px] overflow-auto"
    />
  );
};

export default StepTradeTableUI;
